<template>
  <div class="main">
    <c-panel title="Carteirinhas do transporte" titleIcon="fas fa-id-badge">
      <!--
        Itens 14 e 25 do edital.

        25: "registrar os dados da carteirinha de transporte escolar"
        14: "registrar as situações ... para determinar a validade, suspensão e atividades
             sobre o uso do transporte escolar"

        Suspender NÃO apaga: muda a situação e grava um evento com data, motivo e autor.
      -->
      <el-row :gutter="10" class="u-mb-15">
        <el-col :xs="24" :sm="6">
          <el-input v-model="filtro.numero" placeholder="Número" clearable
                    @keyup.native.enter="load" @clear="load"></el-input>
        </el-col>
        <el-col :xs="24" :sm="5">
          <el-select v-model="filtro.situacao" placeholder="Situação" clearable @change="load" style="width:100%">
            <el-option label="Ativa" value="ativa"></el-option>
            <el-option label="Suspensa" value="suspensa"></el-option>
            <el-option label="Cancelada" value="cancelada"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="5">
          <!-- Item 29 — o controle é por ano letivo. -->
          <el-select v-model="filtro.periodo_letivo_id" placeholder="Ano letivo" clearable
                     @change="load" style="width:100%">
            <el-option v-for="p in periodos" :key="p.id" :label="p.nome" :value="p.id"></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="8" class="u-text-right">
          <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
          <el-button v-if="podeOperar" type="primary" icon="el-icon-plus" @click="abrirEmissao">EMITIR</el-button>
        </el-col>
      </el-row>

      <div class="container-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width:130px;">Número</th>
              <th>Usuário</th>
              <th class="hidden-mobile" style="width:70px;">Via</th>
              <th class="hidden-mobile" style="width:110px;">Emissão</th>
              <th style="width:110px;">Validade</th>
              <th style="width:110px;" class="u-text-center">Situação</th>
              <th style="width:200px;" class="u-text-center" v-if="podeOperar">Ações</th>
            </tr>
          </thead>
          <tbody v-if="statusList">
            <tr v-for="c in items" :key="c.id">
              <td><strong>{{ c.numero }}</strong></td>
              <td>{{ c.usuario_nome || ('vínculo #' + c.transporte_usuario_id) }}</td>
              <td class="hidden-mobile">{{ c.via }}ª</td>
              <td class="hidden-mobile">{{ formatarData(c.data_emissao) }}</td>
              <td>{{ c.data_validade ? formatarData(c.data_validade) : 'sem prazo' }}</td>
              <td class="u-text-center">
                <el-tag :type="corSituacao(c.situacao_efetiva)" size="mini">
                  {{ (c.situacao_efetiva || '').toUpperCase() }}
                </el-tag>
              </td>
              <td class="u-text-center acao" v-if="podeOperar">
                <el-button @click="verEventos(c)" title="Histórico" type="info" icon="el-icon-time"
                           size="mini" plain class="u-mr-5"></el-button>
                <el-button v-if="c.situacao === 'ativa'" @click="abrirAcao(c, 'suspender')"
                           title="Suspender" type="warning" icon="el-icon-remove-outline"
                           size="mini" plain class="u-mr-5"></el-button>
                <el-button v-if="c.situacao === 'suspensa'" @click="abrirAcao(c, 'reativar')"
                           title="Reativar" type="success" icon="el-icon-refresh-left"
                           size="mini" plain class="u-mr-5"></el-button>
                <el-button v-if="c.situacao !== 'cancelada'" @click="abrirAcao(c, 'segundaVia')"
                           title="2ª via" type="primary" icon="el-icon-document-copy"
                           size="mini" plain class="u-mr-5"></el-button>
                <el-button v-if="c.situacao !== 'cancelada'" @click="abrirAcao(c, 'cancelar')"
                           title="Cancelar" type="danger" icon="el-icon-close" size="mini" plain></el-button>
              </td>
            </tr>
            <tr v-if="items.length === 0">
              <td :colspan="podeOperar ? 7 : 6" class="u-text-center">Nenhuma carteirinha encontrada.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ============ Emissão — item 25 ============ -->
      <el-dialog title="Emitir carteirinha" :visible.sync="dialogEmissao" width="620px" append-to-body>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24">
              <el-form-item label="Usuário do transporte *">
                <el-select v-model="formEmissao.transporte_usuario_id" filterable remote clearable
                           :remote-method="buscarVinculo" :loading="buscando"
                           placeholder="Digite o nome do aluno ou servidor" style="width:100%">
                  <el-option v-for="v in vinculos" :key="v.id"
                             :label="v.nome + (v.rota ? ' — ' + v.rota : '')" :value="v.id"></el-option>
                </el-select>
                <small class="u-text-muted">
                  Só aparecem usuários já vinculados ao transporte na sua instituição.
                </small>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Número (em branco = automático)">
                <el-input v-model="formEmissao.numero" maxlength="30"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Emissão">
                <el-date-picker v-model="formEmissao.data_emissao" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-form-item label="Validade (em branco = sem prazo)">
                <el-date-picker v-model="formEmissao.data_validade" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogEmissao = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="emitir" :loading="salvando"
                     :disabled="!formEmissao.transporte_usuario_id">EMITIR</el-button>
        </span>
      </el-dialog>

      <!-- ============ Ações — item 14 ============ -->
      <el-dialog :title="tituloAcao" :visible.sync="dialogAcao" width="520px" append-to-body>
        <el-alert v-if="acao === 'suspender'" type="warning" show-icon :closable="false" class="u-mb-15"
                  title="A carteirinha não é apagada"
                  description="A situação muda e o motivo fica registrado no histórico.">
        </el-alert>
        <el-alert v-if="acao === 'cancelar'" type="error" show-icon :closable="false" class="u-mb-15"
                  title="Cancelamento é definitivo"
                  description="Uma carteirinha cancelada não é reativada nem gera 2ª via.">
        </el-alert>
        <el-form label-position="top">
          <el-form-item label="Motivo *"><el-input v-model="formAcao.motivo" maxlength="191"></el-input></el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogAcao = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="primary" @click="confirmarAcao" :loading="salvando">CONFIRMAR</el-button>
        </span>
      </el-dialog>

      <!-- ============ Histórico de eventos — o "atividades sobre o uso" do item 14 ============ -->
      <el-dialog title="Histórico da carteirinha" :visible.sync="dialogEventos" width="620px" append-to-body>
        <table class="table table-striped">
          <thead><tr><th style="width:120px;">Data</th><th style="width:130px;">Evento</th><th>Motivo</th></tr></thead>
          <tbody>
            <tr v-for="e in eventos" :key="e.id">
              <td>{{ formatarData(e.data_evento) }}</td>
              <td>{{ rotuloEvento(e.evento) }}</td>
              <td>{{ e.motivo || '—' }}</td>
            </tr>
            <tr v-if="eventos.length === 0"><td colspan="3" class="u-text-center">Nenhum evento.</td></tr>
          </tbody>
        </table>
        <span slot="footer"><el-button @click="dialogEventos = false">FECHAR</el-button></span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
const EVENTOS = { emissao: 'Emissão', suspensao: 'Suspensão', reativacao: 'Reativação',
                  cancelamento: 'Cancelamento', segunda_via: '2ª via' }

export default {
  components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },

  data: () => ({
    statusList: false, salvando: false, buscando: false,
    items: [], periodos: [], vinculos: [], eventos: [],
    filtro: { numero: '', situacao: '', periodo_letivo_id: '' },
    dialogEmissao: false, dialogAcao: false, dialogEventos: false,
    formEmissao: {}, formAcao: {}, acao: '', alvo: null
  }),

  computed: {
    podeOperar () { return [0, 1, 4, 5, 6, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    base () { return `${this.$store.state.config.baseUrlApi}/api/transporte-escolar` },
    tituloAcao () {
      return { suspender: 'Suspender carteirinha', reativar: 'Reativar carteirinha',
               cancelar: 'Cancelar carteirinha', segundaVia: 'Emitir 2ª via' }[this.acao] || ''
    }
  },

  mounted () { this.carregarPeriodos(); this.load() },

  methods: {
    formatarData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },
    rotuloEvento (e) { return EVENTOS[e] || e },

    corSituacao (s) {
      return { ativa: 'success', suspensa: 'warning', cancelada: 'danger', vencida: 'info' }[s] || 'info'
    },

    carregarPeriodos () {
      this.$axios.get(`${this.base}/periodos`, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (!r.data || r.data.erro) return
          this.periodos = r.data.periodos || []
        }).catch(() => {})
    },

    load () {
      this.statusList = false
      this.$axios.post(`${this.base}/carteirinha/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.statusList = true
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.items = r.data.data || []
        }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },

    buscarVinculo (termo) {
      if (!termo || termo.length < 3) { this.vinculos = []; return }
      this.buscando = true

      this.$axios.post(`${this.base}/transporte-aluno/getAllPaginate`,
                       { nome: termo, per_page: 50 }, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.buscando = false
          if (!r.data || r.data.erro) { this.vinculos = []; return }

          this.vinculos = (r.data.data || []).map(v => ({
            id: v.id,
            nome: (v.aluno && (v.aluno.nome_social_aluno || v.aluno.nome)) ||
                  (v.servidor && v.servidor.nome) || ('vínculo #' + v.id),
            rota: v.rota ? v.rota.nome : null
          }))
        }).catch(() => { this.buscando = false; this.vinculos = [] })
    },

    abrirEmissao () {
      this.formEmissao = { transporte_usuario_id: '', numero: '',
                           data_emissao: this.$moment().format('YYYY-MM-DD'), data_validade: '' }
      this.vinculos = []
      this.dialogEmissao = true
    },

    emitir () {
      this.salvando = true
      this.$axios.post(`${this.base}/carteirinha/emitir`, this.formEmissao, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogEmissao = false
          window.eventBus.$emit('alert', { msg: 'Carteirinha emitida.', type: 'success' })
          this.load()
        }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    abrirAcao (c, acao) {
      this.alvo = c
      this.acao = acao
      this.formAcao = { motivo: '' }
      this.dialogAcao = true
    },

    confirmarAcao () {
      if (!this.formAcao.motivo) {
        return window.eventBus.$emit('alert', { msg: 'Informe o motivo.', type: 'warning' })
      }

      this.salvando = true

      this.$axios.post(`${this.base}/carteirinha/${this.acao}/${this.alvo.id}`, this.formAcao,
                       this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogAcao = false
          window.eventBus.$emit('alert', { msg: 'Operação realizada.', type: 'success' })
          this.load()
        }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    verEventos (c) {
      this.eventos = []
      this.$axios.get(`${this.base}/carteirinha/getById/${c.id}`, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.eventos = r.data.eventos || []
          this.dialogEventos = true
        }).catch(e => this.$store.commit('throwException', e))
    }
  }
}
</script>
